/*
 * @description: 系统路由配置
 * @author: Vincent
 * @since: 2022-06-21 11:03:46
 * @version: 1.0
 */
import HomeLayout from '@/app/home/views/components/HomeLayout.vue'
export default [
  {
    path: '/supplier',
    component: HomeLayout,
    children: [
      // 企业基本信息
      {
        path: 'supplier-base-info',
        component: () => import('@/app/supplier/views/supplier-base-info'),
        name: 'SupplierBaseInfo',
        meta: { title: 'module.supplier.0986810-0', icon: 'guide', keepAlive: true, whiteList:true}
      },
      // 联系人及服务范围
      {
        path: 'supplier-service-range',
        component: () => import('@/app/supplier/views/supplier-service-range'),
        name: 'SupplierServiceRange',
        meta: { title: 'module.supplier.0986810-1', icon: 'guide', keepAlive: true, whiteList: true}
      },
      // 企业纳税信息
      {
        path: 'supplier-tax-info',
        component: () => import('@/app/supplier/views/supplier-tax-info'),
        name: 'SupplierTaxInfo',
        meta: { title: 'module.supplier.0986810-2', icon: 'guide', keepAlive: true, whiteList: true}
      },
      // 绩效整改报告
      {
        path: 'eva-rectify-list',
        component: () => import('@/app/evaluate/views/eva-rectify-list'),
        name: 'SupplierEvaRectifyList',
        meta: { title: 'module.supplier.0986810-3', icon: 'guide', keepAlive: true, whiteList: true}
      },
      // 评估报告查询
      {
        path: 'eva-report-list',
        component: () => import('@/app/evaluate/views/eva-report-list'),
        name: 'SupplierEvaReportList',
        meta: { title: 'module.supplier.0986810-4', icon: 'guide', keepAlive: true, whiteList: true}
      },
       // 我的绩效
       {
        path: 'achieve',
        component: () => import('@/app/achieve/index'),
        name: 'achieve',
        meta: { title: 'module.supplier.0986810-5', icon: 'guide', keepAlive: true, whiteList: true}
      },
       // 绩效详情
       {
        path: 'achieveDetail',
        component: () => import('@/app/achieve/detail'),
        name: 'achieveDetail',
        meta: { title: 'module.supplier.0986810-6', icon: 'guide', keepAlive: true, whiteList: true}
      }
    ]
  }

]

